import { ICommonObject } from "./common.interface";

export enum SwapStatus {
  not_started = 0,
  in_progess = 1,
  complete = 2,
  failed = 3,
  rejected = 4,
  approval_pending = 5,
  confirm_pending = 6,
}

export const languages = [
  {
    name: "Arabic",
    value: "ar",
    flag: "ar",
  },
  {
    name: "Bulgarian",
    value: "bg",
    flag: "bg",
  },
  {
    name: "English",
    value: "en",
    flag: "en",
  },
  {
    name: "Chinese (simplified)",
    value: "zh-hans",
    flag: "cn",
  },
  {
    name: "Chinese (traditional) ",
    value: "zh-hant",
    flag: "cn",
  },
  {
    name: "Czech",
    value: "cz",
    flag: "cz",
  },
  {
    name: "Dutch",
    value: "nl",
    flag: "nl",
  },
  {
    name: "French",
    value: "fr",
    flag: "fr",
  },
  {
    name: "German",
    value: "de",
    flag: "de",
  },
  {
    name: "Greek",
    value: "el",
    flag: "el",
  },
  {
    name: "Hungarian",
    value: "hu",
    flag: "hu",
  },

  {
    name: "Indonesian",
    value: "id",
    flag: "id",
  },
  {
    name: "Italian",
    value: "it",
    flag: "it",
  },
  {
    name: "Japanese",
    value: "jp",
    flag: "jp",
  },
  {
    name: "Korean",
    value: "kr",
    flag: "kr",
  },
  {
    name: "Persian",
    value: "fa",
    flag: "fa",
  },
  {
    name: "Polish",
    value: "pl",
    flag: "pl",
  },
  {
    name: "Portuguese",
    value: "pt",
    flag: "pt",
  },
  {
    name: "Romanian",
    value: "ro",
    flag: "ro",
  },
  {
    name: "Russian",
    value: "ru",
    flag: "ru",
  },
  {
    name: "Slovak",
    value: "sk",
    flag: "sk",
  },
  {
    name: "Spanish",
    value: "es",
    flag: "es",
  },
  {
    name: "Thai",
    value: "th",
    flag: "th",
  },
  {
    name: "Turkish",
    value: "tr",
    flag: "tr",
  },
  {
    name: "Vietnamese",
    value: "vn",
    flag: "vn",
  },
];

export enum CTAStatus {
  none,
  eth,
  usdt,
  transak,
}

export function getClickId() {
  let getCookie = (name: string) => {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };
  let urlParams = new URLSearchParams(document.location.search);
  let clickId;
  clickId = getCookie("clickId");
  if (urlParams.get("clickId")) {
    // always take clickId from URL if present
    clickId = urlParams.get("clickId");
    document.cookie = "clickId=" + clickId + ";max-age=15778462";
  }

  return clickId ? clickId : "";
}

export function getSource() {
  let getCookie = (name: string) => {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };
  let urlParams = new URLSearchParams(document.location.search);
  let source;
  source = getCookie("source");
  if (urlParams.get("source")) {
    // always take source from URL if present
    source = urlParams.get("source");
    document.cookie = "source=" + source + ";max-age=15778462";
  }

  return source ? source : "";
}

export function convertNum(value: number, decimalNo: number = 2) {
  // num = +(+num).toFixed(decimalNo);
  const num =
    Math.floor(value * Math.pow(10, decimalNo)) / Math.pow(10, decimalNo);
  let nf = new Intl.NumberFormat("en-US");
  nf.format(num); // "1,234,567,890"
  return nf.format(num);
}

export function convertNumToCurr(num: number) {
  // Nine Zeroes for Billions
  return Math.abs(Number(num)) >= 1.0e9
    ? Math.round((Math.abs(Number(num)) / 1.0e9) * 100) / 100 + "B"
    : // Six Zeroes for Millions
    Math.abs(Number(num)) >= 1.0e6
      ? Math.round((Math.abs(Number(num)) / 1.0e6) * 100) / 100 + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(num)) >= 1.0e3
        ? Math.round((Math.abs(Number(num)) / 1.0e3) * 100) / 100 + "K"
        : Math.abs(Number(num));
}

export function convertNumTwoDec(value: number, decimalNo: number = 2) {
  return Math.floor(value * Math.pow(10, decimalNo)) / Math.pow(10, decimalNo);
}

export function convertNumToRoman(value: number, isBronze: boolean = false) {
  const values = [5, 4, 1];
  const symbols = ['V', 'IV', 'I'];
  let romanValue = "";

  value = (value + (isBronze ? 0 : 1)) % 5 || 5;

  for (let i = 0; i < values.length; i++) {
    while (value >= values[i]) {
      romanValue += symbols[i];
      value -= values[i];
    }
  }
  return romanValue;
}

export function verifyLanguage(lang: string): boolean {
  const validLang = languages.filter((x) => x.value === lang);
  return validLang.length > 0 ? true : false;
}

export const country_list = [
  { name: "Albania", code: "AL" },
  { name: "Åland Islands", code: "AX" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "Andorra", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas (the)", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia (Plurinational State of)", code: "BO" },
  { name: "Bonaire, Sint Eustatius and Saba", code: "BQ" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory (the)", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cabo Verde", code: "CV" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cayman Islands (the)", code: "KY" },
  { name: "Central African Republic (the)", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands (the)", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros (the)", code: "KM" },
  { name: "Congo (the Democratic Republic of the)", code: "CD" },
  { name: "Congo (the)", code: "CG" },
  { name: "Cook Islands (the)", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Curaçao", code: "CW" },
  { name: "Cyprus", code: "CY" },
  { name: "Czechia", code: "CZ" },
  { name: "Côte d'Ivoire", code: "CI" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic (the)", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Eswatini", code: "SZ" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (the) [Malvinas]", code: "FK" },
  { name: "Faroe Islands (the)", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories (the)", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia (the)", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and McDonald Islands", code: "HM" },
  { name: "Holy See (the)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran (Islamic Republic of)", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea (the Democratic People's Republic of)", code: "KP" },
  { name: "Korea (the Republic of)", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People's Democratic Republic (the)", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands (the)", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia (Federated States of)", code: "FM" },
  { name: "Moldova (the Republic of)", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands (the)", code: "NL" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger (the)", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands (the)", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestine, State of", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines (the)", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Republic of North Macedonia", code: "MK" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation (the)", code: "RU" },
  { name: "Rwanda", code: "RW" },
  { name: "Réunion", code: "RE" },
  { name: "Saint Barthélemy", code: "BL" },
  { name: "Saint Helena, Ascension and Tristan da Cunha", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Martin (French part)", code: "MF" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Sint Maarten (Dutch part)", code: "SX" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "South Sudan", code: "SS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan (the)", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan (Province of China)", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands (the)", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates (the)", code: "AE" },
  {
    name: "United Kingdom of Great Britain and Northern Ireland (the)",
    code: "GB",
  },
  { name: "United States Minor Outlying Islands (the)", code: "UM" },
  { name: "United States of America (the)", code: "US" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela (Bolivarian Republic of)", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands (British)", code: "VG" },
  { name: "Virgin Islands (U.S.)", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

export function getParamWithoutCookie(paramName: string) {
  let urlParams = new URLSearchParams(document.location.search);
  let param;
  if (urlParams.get(paramName)) {
    // always take clickId from URL if present
    param = urlParams.get(paramName);
  }

  return param ? param : "";
}

export function getBrowserName() {
  const agent = window.navigator.userAgent.toLowerCase();
  switch (true) {
    case agent.indexOf("edge") > -1:
      return "edge";
    case agent.indexOf("opr") > -1 && !!(<any>window).opr:
      return "opera";
    case agent.indexOf("chrome") > -1 && !!(<any>window).chrome:
      return "chrome";
    case agent.indexOf("trident") > -1:
      return "ie";
    case agent.indexOf("firefox") > -1:
      return "firefox";
    case agent.indexOf("safari") > -1:
      return "safari";
    default:
      return "other";
  }
}

export function getParam(paramName: string) {
  let getCookie = (name: string) => {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  let urlParams = new URLSearchParams(document.location.search);
  let param: any = getCookie(paramName);

  if (urlParams.get(paramName)) {
    // always take clickId from URL if present
    param = urlParams.get(paramName);
    document.cookie = paramName + "=" + param + ";max-age=15778462";
  }

  return param ? param : "";
}

export const casinoOfferLinks = [
  "https://record.wsmaffiliates.com/_OYeaPWW-7QHUOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_fVCPG7EMUV7UOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_jngPrA_F5P_UOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_2HBLPHNE3djUOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_Vep5d-bnJ87UOsjNOfgKeWNd7ZgqdRLk/1/",
];

export const casinoFreeBetLinks = [
  "https://record.wsmaffiliates.com/_BVfiJm57JnrUOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_OYeaPWW-7QHUOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_fVCPG7EMUV7UOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_jngPrA_F5P_UOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_2HBLPHNE3djUOsjNOfgKeWNd7ZgqdRLk/1/",
  "https://record.wsmaffiliates.com/_Vep5d-bnJ87UOsjNOfgKeWNd7ZgqdRLk/1/",
];

export enum LootBoxesTabsEnum {
  PLAY = "PLAY",
  MY_PRIZES = "MY_PRIZES",
}
export enum PRIZE_STATUS {
  WITHDRAWN = "withdraw",
  CASH_SWAP = "cashout",
  NON_COMPATIBLE = "non_compatible",
  KEPT = "kept",
  WON = "won",
  PROCESSING = "processing"
}

export enum ACTIONS {
  CLICK = "CLICK",
  CHECK_BOX = "CHECK_BOX",
}

export enum SPIN_WIN_PRIZES {
  NFT = "NFT",
  CASINO_TOKEN = "CASINO_TOKEN",
  CASINO_BONUS = "CASINO_BONUS",
  FREE_SPIN = "FREE_SPIN",
  CASH = "CASH",
  CUSTOM = "CUSTOM"
}

export enum SORT_ENUM {
  ASC = "ASC",
  DESC = "DESC",
  PRICE_USD = "PRICE_USD",
  PRICE_EURO = "PRICE_EURO"
}


export enum EVENTS {
  WALLET_CONNECTION = "CONNECTING_WALLET",
}

export enum CURRENCY {
  USD = "USD",
  EURO = "EUR"
}

export enum CURRENCY_SYMBOL {
  USD = "$",
  EURO = "€"
}

export enum BLOCKCHAINS {
  ETH = "ETH",
  POLYGON = "POLYGON",
  BSC = "BSC",
}

export const CHAINS: ICommonObject<string> = {
  'ETH': 'ethereum',
  'POLYGON': 'matic',
  'BSC': "bsc",
}

export const TIERS_LEVELS = {
  bronze: { tier: "bronze", level: 0 },
  silver: { tier: "silver", level: 1 },
  gold: { tier: "gold", level: 2 },
  platinum: { tier: "platinum", level: 3 }
};

export function getEllipsis(text: string, max: number): string {
  if (text.length > max) {
    return `${text.substring(0, max)}...`;
  }
  return text;
}

export enum PLATFORM_TYPES {
  MOBILE = "MOBILE",
  WEBSITE = "WEBSITE",
}

export enum VIP_CONFIG_TYPES {
  BASIC = "BASIC",
  RAKEBACK = "RAKEBACK",
  CASHBACK = "CASHBACK",
  RELOAD = "RELOAD",
}

export enum STATUS_CODES {
  NOT_FOUND = 404,
  UNAUTHORIZED = 401,
  BAD_REQUEST = 400
}

export const VIP_BENEFITS_TYPES = {
  CASHBACK: {
    type: "CASHBACK",
    key: "vip_benefit_cashback",
    isAmount: true,
    svg: "./assets/images/svg-icons/vip-benefits/cashback.svg",
  },
  RAKEBACK: {
    type: "RAKEBACK",
    key: "vip_benefit_rakeback",
    isAmount: true,
    svg: "./assets/images/svg-icons/vip-benefits/rakeback.svg",
  },
  WEEKLY_DEPOSIT_BONUS: {
    type: "WEEKLY_DEPOSIT_BONUS",
    key: "vip_benefit_weekly_deposit",
    svg: "./assets/images/svg-icons/vip-benefits/deposit-bonus.svg",
  },
  DISCRETIONARY_BONUS: {
    type: "DISCRETIONARY_BONUS",
    key: "vip_benefit_discretionary_bonus",
    svg: "./assets/images/svg-icons/vip-benefits/discretionary-bonus.svg",
  },
  SPECIAL_CHALLENGES: {
    type: "SPECIAL_CHALLENGES",
    key: "vip_benefit_special_challenges",
    svg: "./assets/images/svg-icons/vip-benefits/special-challenges.svg",
  },
  VIP_MANAGER: {
    type: "VIP_MANAGER",
    key: "vip_benefit_vip_manager",
    svg: "./assets/images/svg-icons/vip-benefits/vip-manager.svg",
  },
};

export const LAST_LEVEL = { tier: 'platinum', level: 19 };

export enum LOADER_TYPES {
  SHIMMER = "SHIMMER",
  SPINNER = "SPINNER",
  GIF = "GIF"
}

export enum STORAGE_KEYS {
  FROM_MY_NFTS = "fromMyNFTs",
  SESSION = 'session',
  CURRENT_LANG = 'currentlang',
  IS_DEMO = 'isDemo',
  CURRENCY = 'currency',
  PLATFORM = 'platform'
}

export enum IDENTIFIERS {
  WITHDRAW_NFT = 'WITHDRAW_NFT',
}

export enum CUSTOM_PRIZE_TYPE {
  RECURRING = "RECURRING",
  REPLACEMENT = "REPLACEMENT"
}

export enum LEADERBOARD_TYPES {
  betting_total = 'betting_total',
  casino_batting_total = 'casino_batting_total',
  sports_betting_total = 'sports_betting_total',
  rakeback = 'rakeback',
  total_wagered = 'total_wagered'
}